module.exports = __webpack_public_path__ + "static/media/droplet-icon.bdfcb6a5.svg";